var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"flex space-x-6",attrs:{"aria-label":"Tabs"}},_vm._l((_vm.textTabItems),function(item,index){return _c('router-link',{key:index,attrs:{"to":_vm.localePath({
                path: '/messages/' + item.name,
                params: { name: item.name },
            })}},[_c('TextTab',{attrs:{"text":item.text,"tab":item.tab,"active":item.active}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }